// extracted by mini-css-extract-plugin
module.exports = {"link":"CampaignLink_link__1HXYa","text":"CampaignLink_text__1dw74","icon":"CampaignLink_icon__2vWED","list":"CampaignLink_list__2HSbS"};